module.exports = __webpack_public_path__ + "img/male.d259b979.jpg";